import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Demo from './pages/Demo';
import Dev from './pages/Dev';
import LSMTree from './pages/LSMTree';
import TokenBucket from './pages/TokenBucket';
import FixedWindowCounter from './pages/FixedWindowCounter';
import SlidingWindowLog from './pages/SlidingWindowLog';
import Blogs from './pages/Blogs';
import StateOfAI from './pages/StateOfAI';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Separate component so useLocation can be called inside BrowserRouter
function AppContent() {
  const location = useLocation();
  const isDemo = location.pathname === '/demo';
  const isDevSubpage = location.pathname.startsWith('/dev/');

  useEffect(() => {
    if (location.hash) {
      window.requestAnimationFrame(() => {
        document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
      });
      return;
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname, location.hash]);

  return (
    <div className="App min-h-screen bg-white dark:bg-gray-950 transition-colors duration-200">
      {!isDemo && !isDevSubpage && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/ai-got-good-before-it-got-dependable" element={<StateOfAI />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/dev" element={<Dev />} />
        <Route path="/dev/lsm-tree" element={<LSMTree />} />
        <Route path="/dev/token-bucket" element={<TokenBucket />} />
        <Route path="/dev/fixed-window-counter" element={<FixedWindowCounter />} />
        <Route path="/dev/sliding-window-log" element={<SlidingWindowLog />} />
      </Routes>
      {!isDemo && !isDevSubpage && <Footer />}
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
